/* Tổng đài Sales: trạng thái trực máy và cuộc gọi từ số lạ (chưa có hồ sơ) — lưu trên máy, chờ nối tổng đài */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { uid } from './logic';

export type AgentStatus = 'ready' | 'break';
export interface UnknownCall {
  id: string;
  at: number;
  phone: string;
  /** true = nhỡ; false = đã nghe */
  missed: boolean;
  /** Người nghe máy */
  by?: string;
  /** Đã gọi lại / tạo khách xong */
  doneAt?: number;
  doneBy?: string;
}

interface CallStore {
  status: AgentStatus;
  setStatus: (s: AgentStatus) => void;
  unknown: UnknownCall[];
  addUnknown: (c: Omit<UnknownCall, 'id'>) => UnknownCall;
  doneUnknown: (id: string, by: string) => void;
}

/** Giữ tối đa N cuộc gọi số lạ trên máy */
const MAX_UNKNOWN = 200;

export const useCallStore = create<CallStore>()(
  persist(
    (set) => ({
      status: 'ready',
      setStatus: (status) => set({ status }),
      unknown: [],
      addUnknown: (c) => {
        const u = { ...c, id: uid() };
        set((s) => ({ unknown: [u, ...s.unknown].slice(0, MAX_UNKNOWN) }));
        return u;
      },
      doneUnknown: (id, by) => set((s) => ({ unknown: s.unknown.map((x) => (x.id === id ? { ...x, doneAt: Date.now(), doneBy: by } : x)) })),
    }),
    { name: 'khothi-tele-callcenter-v1', version: 1 },
  ),
);
